import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography } from '@mui/material';
import ReactHtmlParser from 'html-react-parser';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import grey from '../../pages/money-fiesta/images/links/b-blue-boxes.png';
import Bg from '../../pages/money-fiesta/images/links/background.jpg';
import Blue from '../../pages/money-fiesta/images/links/blue-boxes.png';
import FreeMoney from '../../pages/money-fiesta/images/links/choose your free money.png';
import confirm from '../../pages/money-fiesta/images/links/confirm button.png';
import Faq from '../../pages/money-fiesta/images/links/faqs.png';
import Logo from '../../pages/money-fiesta/images/links/logo.png';
import footer from '../../pages/money-fiesta/images/links/Shop. Cashback. Free Money_.png';
import Wending from '../../pages/money-fiesta/images/links/wending machine.png';
import Money from '../../pages/money-fiesta/images/links/your money your rules.png';
import { isValidValue } from '../../utils/function';

const faqs = [
  {
    question: "What is the Free Money Fiesta?",
    answer: "The Free Money Fiesta is a limited time offer where users can set a personalized Cashback target and earn an additional bonus Cashback (Free Money) if they achieve their goal within campaign duration. "
  },
  {
    question: "How do I participate in the campaign?",
    answer: "Simply select your Cashback goal from the available options and start shopping via the CashKaro app or website. "
  },
  {
    question: "Do I need to register separately?",
    answer: "No, there is no separate registration required. Just choose your goal and start shopping!"
  },
  {
    question: "What happens if I achieve my Cashback goal?",
    answer: `If you achieve your selected target within the campaign period, your bonus will be credited within 48 hours. Please note: 
    <ul>
    <li>Referral earnings, special bonuses, Amazon Recharge, and Swiggy orders will not count towards your Cashback goal.</li>
    <li>Only confirmed Cashback/Rewards at the end of the campaign will be considered.</li>
    <li>Your bonus Cashback (Free Money) will be updated by 30th July.</li>
    </ul>
    `
  },
  {
    question: "Can I change my Cashback goal after selecting one?",
    answer: "No, once you select a Cashback goal, it cannot be changed for that campaign period."
  },
  {
    question: "How do I track my progress?",
    answer: "You can track your Cashback progress on the Cashback goal page, where a progress bar will be updated daily."
  },
  {
    question: "Where can I shop to earn Cashback for this campaign?",
    answer: `You can shop from any of your favourite brands listed on CashKaro which offers Cashback, including:
    <ul>
    <li>Flipkart, Amazon, Myntra, Ajio & more</li>
    <li>Flash deals & exclusive offers</li>
    <li>Credit card offers (earn up to ₹2200 Rewards!)</li>
    <li>Biggest sales events</li>
    <li>Referral bonuses, any other special recharges. Amazon Recharges & Swiggy will not be considered.
    </li>
    </ul>`,
  },
  {
    question: "How do I track my progress?",
    answer: "You can track your Cashback progress on the Cashback goal page, where a progress bar will be updated daily."
  },
  {
    question: "When will my bonus Cashback be credited?",
    answer: `Your bonus Cashback will be added to your CashKaro account within 48 hours of meeting the goal &, it will be Confirmed after the campaign ends and once all your transactions are verified. Please Note:
    <ul>
    <li>Referral earnings, special bonuses, Amazon Recharge, and Swiggy orders will not count towards your Cashback goal. </li>
    <li>Only confirmed Cashback/Rewards at the end of the campaign will be considered. </li>
    </ul>`,
  },
  {
    question: "What happens if my order gets cancelled or refunded?",
    answer: "If any of your transactions are cancelled or refunded, they will not count toward your Cashback goal. Your progress bar will be adjusted accordingly."
  },
  {
    question: "Can I participate again in the next campaign?",
    answer: "Yes! If we run another Free Money Fiesta campaign, you will get a new personalized target and can participate again.",
  },
  {
    question: "What happens if I don't meet my Cashback goal?",
    answer: "There's no penalty! You will still receive the Cashback you earned during the campaign, but you won't be eligible for the bonus Cashback."
  },
  {
    question: "Are there any exclusions or limitations?",
    answer: `Yes, here are some key limitations: 
   <ul>
    <li>Transactions must be tracked and approved to count toward your goal. </li>
<li>Fraudulent transactions or multiple accounts created to misuse the offer will not be considered.</li> 
<li>Cashbacks from Cancelled/Retunred-Refuned orders/Referral bonus/Amazon Recharges/Swiggy and any other Transactions won’t count towards your target.</li>
</ul>`, 
  },
  {
    question: "What if I have more questions?",
    answer: "For any additional queries, please click on the Help option in the CashKaro App or Website to connect with our customer support team.",
  }
];

const Terms = [
  {
    question: "What is the Free Money Fiesta?",
    answer: "Free Money Fiesta is a limited-time campaign that allow users to set a personalized Cashback target and earn extra bonus Cashback upon achieving it within the campaign duration."
  },
  {
    question: "What is my target and what do I get after completing it? ",
    answer: "You can select your Cashback goal target that you want to achieve between the campaign's timeline. If you achieve your goal, you will receive bonus Cashback in addition to your earned Cashback. "
  },
  {
    question: "Who can participate? ",
    answer: "Users who are receiving communications and can see the campaign on their app are eligible to participate. It is applicable for Unique Device, Unique User."
  },
  {
    question: "Campaign Duration",
    answer: "Till 31th May"
  },
  {
    question: "How do I get the points?",
    answer: `<ul>
    <li>Shop from your favourite brands</li>
    <li>Shop from Flash Deals</li>
    <li>Apply credit cards and get up to ₹2200 Rewards </li>
    <li>Shop from the biggest sales </li>
    <li>Shop from anywhere on the CashKaro app or website from retailers which offers Cashback on the purchase. Amazon recharges and Swiggy will be excluded.</li>
  </ul>`},
  {
    question: "Benefits",
    answer: "Upon achieving your Cashback milestone, you will receive an additional bonus Cashback. The bonus Cashback (Free Money), will be credited within 48 hours of you achieving your Cashback goal. Please note that referral, any other special bonuses, Amazon recharge and Swiggy will be excluded from the tally of your Cashback goal. In the end of the campaign, only confirmed Cashback/rewards would be considered towards goal achievement. The bonus Cashback (Free Money) will be confirmed by 31st July."
  },
  {
    question: "Do I have to register for the contest?",
    answer: "No separate registration is required. Simply participate by selecting your Cashback goal."
  },
  {
    question: "Exclusions and Limitations",
    answer: `<ul>
    <li>Transactions that are cancelled, refunded, or deemed fraudulent will not be counted toward your Cashback goal.</li>
    <li>Referral, any other special bonuses, Amazon recharges and Swiggy will not be considered.</li>
    <li>The campaign is only valid on eligible purchases made through the CashKaro platform.</li>
    <li>Once users select their Cashback goal, it cannot be reselected or cancelled.</li>
  </ul>`},
  {
    question: "Adjustments and Termination",
    answer: "CashKaro reserves the right to modify or terminate the campaign at any time without prior notice. In case of discrepancies, including transaction cancellations or fraudulent activities, CashKaro reserves the right to adjust scores and rankings. No upward adjustments in rankings will occur due to another participant's score adjustment; rankings may only decrease."
  },
  {
    question: "When is the progress bar updated? ",
    answer: "The progress bar will be updated daily, reflecting tracked transactions from the previous day. Cashback with the extra bonus will be determined based on the total transactions accumulated during the campaign period."
  },
  {
    question: "Declaration by User ",
    answer: "These Terms shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts of Gurugram, Haryana. By participating in the CashKaro Cashback Goal campaign, you acknowledge that you have read, understood, and agreed to these Terms and Conditions."
  },
];

const style = {
  border: '1px solid transparent',
  marginLeft: '1rem',
  marginRight: '1rem',
  borderImageSource: 'linear-gradient(140.1deg, #525252 -8.09%, #0E0E0E 35.68%)',
  borderImageSlice: 1,
  margin: '0 auto',
  background: 'radial-gradient(97.73% 123.25% at 0% 0%, #1F1F1F 0%, #0D0D0D 69.18%)',
  borderRadius: '24px',
  WebkitMaskImage: "linear-gradient(white, white)"
};

const stylee = {
  margin: '0 auto',
  background: "#0D0D0D"
}

const options = [
  {
    id: 1,
    title: "Free Money",
    prize: "100",
    description: "Cashback Goal",
    cashback: "2000",
  },
  {
    id: 2,
    title: "Free Money",
    prize: "150",
    description: "Cashback Goal",
    cashback: "2500",
  },
  {
    id: 3,
    title: "Free Money",
    prize: "200",
    description: "Cashback Goal",
    cashback: "3000",
  },
];

export default function MoneyFiestaMayTg() {
  const [selected, setSelected] = useState({});
  const [data, setData] = useState([]);
  const navigate = useNavigate();
const [isRegistrationClosed, setIsRegistrationClosed] = useState(false);
const [alertOpen, setAlertOpen] = useState(false);
  const [message, setMessage] = useState();
  const checkRegistrationDeadline = () => {
    const currentDate = new Date();
    const deadlineDate = new Date('2025-05-31T23:59:59');
    return currentDate > deadlineDate;
  };

  const handleSelect = (option) => {
    setSelected(option);
  };

  const setTarget = async () => {
    try {
      if (isRegistrationClosed) {
        setMessage("Registration for this campaign is now closed.");
        setAlertOpen(true);
        return;
      }

      const params = new URLSearchParams(window.location.search);
      let ck_id = params.get('userid') || params.get('user_id') || params.get('userId') || params.get('ck_id') || params.get('ckid');
      if (isValidValue(ck_id)) {
        if (selected?.cashback && selected?.prize) {
          let response = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/create_fmf_may`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              ck_id: ck_id,
              selected_cashback_goal: selected.cashback,
              selected_free_money: selected.prize
            })
          });

          response = await response.json();
          localStorage.setItem('fiesta_ck_id_may_tg', ck_id);
          navigate('/money-fiesta-may-tg/congrats');
        }
      } else {
        navigate(`/campaign-error?ck_id=${ck_id}`)
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getGoals = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      let ck_id = params.get('userid') || params.get('user_id') || params.get('userId') || params.get('ck_id') || params.get('ckid');
      // if (ck_id != null && ck_id != 'null') {
      if (isValidValue(ck_id)) {
        let response = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/getusergoal_fmf_may?userId=${ck_id}`);
        response = await response.json();
        setData([
          {
            id: 1,
            title: "Free Money",
            prize: response?.user_data?.free_money_1,
            description: "Cashback Goal",
            cashback: response?.user_data?.cashback_goal_1,
          },
          {
            id: 2,
            title: "Free Money",
            prize: response?.user_data?.free_money_2,
            description: "Cashback Goal",
            cashback: response?.user_data?.cashback_goal_2,
          },
          {
            id: 3,
            title: "Free Money",
            prize: response?.user_data?.free_money_3,
            description: "Cashback Goal",
            cashback: response?.user_data?.cashback_goal_3,
          },
        ]);
        setSelected({
          id: 1,
          title: "Free Money",
          prize: response?.user_data?.free_money_1,
          description: "Cashback Goal",
          cashback: response?.user_data?.cashback_goal_1,
        });
      } else {
        console.log('ck id not present');
        navigate(`/campaign-error?ck_id=${ck_id}`)
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getUserData = async () => {
    const params = new URLSearchParams(window.location.search);
    let ck_id = params.get('userid') || params.get('user_id') || params.get('userId') || params.get('ck_id') || params.get('ckid');

    try {
      if (isValidValue(ck_id)) {
        let response = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/getuserdata_fmf_may?ck_id=${ck_id}`);
        response = await response.json();
        if (response?.user_data?.current_cashback >= response?.user_data?.selected_cashback_goal) {
          localStorage.setItem('fiesta_ck_id_may_tg', ck_id);
          navigate("/money-fiesta-may-tg/bonus", { replace: true });
        }

        if (response?.user_data?.selected_cashback_goal) {
          localStorage.setItem('fiesta_ck_id_may_tg', ck_id);
          navigate("/money-fiesta-may-tg/congrats", { replace: true });
        }
      } else {
        navigate(`/campaign-error?ck_id=${ck_id}`)
      }
    } catch (error) {
      console.log(error.message);
    }
  };
useEffect(() => {
      setIsRegistrationClosed(checkRegistrationDeadline());
    }, []);
  
    useEffect(() => {
      let check = localStorage.getItem('fiesta_ck_id_apr');
      if(check){
        navigate('/money-fiesta-april/congrats', {replace: true});
      } else {
        if (isRegistrationClosed) {
          setMessage("Registration for this campaign is now closed.");
          setAlertOpen(true);
          return;
        }
        getGoals();
      }
    }, [isRegistrationClosed]);

  useEffect(() => {
    getGoals();
    getUserData();
  }, []);

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}
        sx={{
          backgroundImage: `url(${Bg})`,
          backgroundSize: 'cover'
        }}>
          {isRegistrationClosed && !localStorage.getItem('fiesta_ck_id_apr') ? (
                              <Box sx={{ 
                                textAlign: 'center', 
                                padding: '2rem',
                                color: '#fff',
                                fontFamily: 'Metropolis',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                minHeight: '100vh'
                              }}>
                                <Typography variant="h4" sx={{ color: '#fce100', marginBottom: '1rem' }}>
                                  Contest Closed
                                </Typography>
                                <Typography>
                                  The registration period for this campaign has ended. Thank you for your interest!
                                </Typography>
                              </Box>
                            ) : (
        <>
          <div>
            <img src={Logo} alt='logo' style={{ width: '100%' }} />
          </div>
          <div style={{ paddingLeft: '5rem', paddingRight: '5rem' }}>
            <img src={Money} alt='Money' style={{ width: '100%' }} />
          </div>
          <div style={{ paddingLeft: '2rem', paddingRight: '2rem', marginTop: '1rem' }}>
            <Typography sx={{ color: '#fff', fontSize: '0.75rem', textAlign: 'center', fontFamily: 'Metropolis' }}>
              Shop on any brand via CashKaro & get free money on achieving your Cashback Goal
            </Typography>
          </div>
          <div style={{ marginTop: '1rem' }}>
            <img src={Wending} alt='Wending' style={{ width: '100%' }} />
          </div>
          <div style={{ marginTop: '3rem', paddingLeft: '5rem', paddingRight: '5rem' }}>
            <img src={FreeMoney} alt='FreeMoney' style={{ width: '100%' }} />
          </div>
          <Grid item xs={12} mt={4} mx={2}>
            <Box sx={{ maxWidth: "328px", margin: "0 auto" }}>
              <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "10px",
                display: 'flex',
                justifyContent: 'center'
              }}>
                {data && data.map((option) => (
                  <div
                    key={option.id}
                    onClick={() => handleSelect(option)}
                    style={{
                      cursor: "pointer",
                      backgroundImage: selected.id === option.id ? `url(${Blue})` : `url(${grey})`,
                      backgroundSize: selected.id === option.id ? "cover" : "contain",
                      backgroundRepeat: "no-repeat",
                      width: selected.id === option.id ? "100%" : "80%",
                      padding: "5px",
                      position: "relative",
                      height: selected?.id == option.id ? "140px" : "98px",
                      paddingTop: selected.id === option.id ? '9%' : '3%',
                      top: selected.id === option.id ? "-20px" : '',
                      backgroundPosition: "top",
                      boxShadow: selected.id === option.id ? "0 4px 8px rgba(0, 0, 0, 0.2)" : "none",
                    }}
                  >
                    <Box sx={{ position: 'absolute', top: selected.id == option?.id ? '28px' : '5px', right: 0, left: 0 }}>
                      <Typography
                        style={{
                          fontFamily: "Metropolis",
                          fontSize: selected === option.id ? "12px" : "10px",
                          color: "#FFFFFF",
                          marginTop: selected === option.id ? "20px" : "",
                          textAlign: 'center'
                        }}
                      >
                        {option.title}
                      </Typography>
                      <Typography
                        style={{
                          fontFamily: "Metropolis",
                          fontSize: selected.id === option.id ? "16px" : "14px",
                          textAlign: "center",
                          fontWeight: "800",
                          color: selected.id === option.id ? "#fce100" : "#000",
                        }}
                      >
                        ₹{option.prize}
                      </Typography>
                      <Typography
                        style={{
                          fontFamily: "Metropolis",
                          fontSize: selected === option.id ? "12px" : "10px",
                          color: "#FFFFFFCC",
                          fontWeight: "400",
                          lineHeight: "18px",
                          textAlign: 'center'
                        }}
                      >
                        {option.description}
                      </Typography>
                      <Typography
                        style={{
                          fontFamily: "Metropolis",
                          fontSize: "1rem",
                          ...{
                            color: selected.id === option.id ? "blue" : "#FFFFFFCC",
                            paddingTop: selected == null ? '10px' : '5px',
                          },
                          fontWeight: "800",
                          lineHeight: "18px",
                          textAlign: 'center'
                        }}
                      >
                        ₹{option.cashback}
                      </Typography>
                    </Box>
                  </div>
                ))}
              </div>
            </Box>
          </Grid>
          <div style={{ paddingLeft: '2rem', paddingRight: '2rem', marginTop: '1rem' }}>
            <Typography sx={{ color: '#fff', fontFamily: 'Metropolis', fontSize: '0.75rem', textAlign: 'center' }}>
              Choose wisely, Once confirmed <span style={{ color: 'yellow' }}>you will not be able to change</span> your Cashback goal & Free money
            </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
            <img src={confirm} alt='confirm' style={{ width: '70%' }} onClick={() => setTarget()} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '4rem' }}>
            <img src={Faq} alt='faq' style={{ width: '30%' }} />
          </div>
          <Box sx={{ paddingX: '18px', marginTop: '3rem' }}>
            {faqs.map((faq, i) => (
              <Box
                key={i}
                sx={{
                  marginBottom: "16px",
                  padding: "2px",
                  background: "transparent",
                  borderRadius: "14px",
                }}
              >
                <Accordion
                  sx={{
                    borderRadius: "14px !important",
                    background: "transparent",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: 600,
                    fontFamily: 'Metropolis',
                    boxShadow: 'none'
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                    sx={{ color: 'yellow' }}>
                    {faq?.question}
                  </AccordionSummary>
                  <AccordionDetails>{ReactHtmlParser(faq?.answer)}</AccordionDetails>
                </Accordion>
              </Box>
            ))}
          </Box>
          <Box sx={{ paddingX: '18px' }} pb={16}>
            <Typography sx={{
              textAlign: 'center',
              paddingTop: '16px',
              fontFamily: "DM Sans",
              marginBottom: '16px',
              color: '#fff',
              fontSize: '12px',
              fontWeight: 600,
              lineHeight: '16px',
              letterSpacing: '3px'
            }}>
              TERMS & CONDITIONS
            </Typography>
            {Terms.map((term, i) => (
              <Box
                key={i}
                sx={{
                  marginBottom: "16px",
                  padding: "2px",
                  borderRadius: "14px",
                  background: "transparent",
                }}
              >
                <Accordion
                  sx={{
                    borderRadius: "14px !important",
                    color: "#fff",
                    fontSize: "14px",
                    background: "transparent",
                    boxShadow: 'none',
                    fontWeight: 600,
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                    sx={{ color: '#fce100' }}>
                    {term?.question}
                  </AccordionSummary>
                  <AccordionDetails>{ReactHtmlParser(term?.answer)}</AccordionDetails>
                </Accordion>
              </Box>
            ))}
          </Box>
          <div style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingBottom: '1rem' }}>
            <img src={footer} alt='footer' width={"100%"} />
          </div>
        </>
 )} 
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
    </Grid>
  );
} 